import data from '../data'
import requestToBOAction from './requestToBO.action'
import { wishTriggers } from '../main'

const removeFromWishlistAction = (sku) => {
  let indexForRemove
  let updatedItem

  for (const item of data.products) {
    if (item.sku === sku) {
      indexForRemove = data.products.indexOf(item)
      if (data.customerId) {
        updatedItem = item
        updatedItem.deletedFromMeta = true
      }
      break
    }
  }

  if (!data.customerId) {
    data.products.splice(indexForRemove, 1)
  } else if (updatedItem) {
    data.products.splice(indexForRemove, 1, updatedItem)
  }

  const requestData = {}

  requestData.sku = sku
  if (data.customerId) {
    requestData.customer_id = data.customerId
    requestData.email = data.customerEmail
  }

  requestToBOAction('REMOVE', requestData)

  wishTriggers.emitEvent('listUpdated', [data.products])
  wishTriggers.emitEvent(`list:${sku}:remove`)
}

export default removeFromWishlistAction
